// This JavaScript file is created by Cision for our ticker performance module.
// This is the first version of this file so far.
// This should be combined with eighter of the ticker html files

var cision = cision || {};
cision.websolution = cision.websolution || {};
cision.websolution.texts = cision.websolution.texts || {};
cision.websolution.settings = cision.websolution.settings || {};
cision.websolution.formatHelpers = cision.websolution.formatHelpers || {};

cision.websolution.performance = !cision.websolution.settings.ticker ? {} : function ($) {

    var settings = $.extend({}, cision.websolution.settings.general),
        accessKey = cision.websolution.settings.ticker.accessKey,
        texts = cision.websolution.texts[settings.uiLanguage];

    function generateUrl(path) {
        var url = settings.useProxyHandler
            ? settings.proxyHandler + '?url=' + settings.serviceEndpoint + path
            : settings.serviceEndpoint + path;

        return url;
    }
    var renderTrades = function (options) {

        if (options) {
            $.extend(settings, options);
        }
        if (!accessKey) {
            console.log("You must provide your ticker access key.");
            return;
        }
        var url = generateUrl('Ticker/' + accessKey + '/Performance');

        $.ajax({
                url: url,
                type: 'GET',
                dataType: 'json'
            })
            .done(function (rawData) {
                var rawInstruments = rawData.Instruments;
                var instruments = $.extend(rawInstruments, texts);
                var sortBySymbol = function (s) {
                    return _.sortBy(s, "Symbol");
                }
                var sortedPerformanceData = sortBySymbol(instruments);
                var htmls = "";
                // Retrieve the Instrument
                for (var instrumentIx = 0; instrumentIx < sortedPerformanceData.length; instrumentIx++) {

                    var objInstrument = sortedPerformanceData[instrumentIx]; // TODO: find the correct instrument, in case we have many in the Module
                    objInstrument.AthDateFormatted = moment(objInstrument.AthDate).locale(settings.uiLanguage).format('DD MMM YYYY');
                    objInstrument.LastUpdateFormatted = moment(objInstrument.LastUpdate).locale(settings.uiLanguage).format('DD MMM YYYY');
                    objInstrument.AtlDateFormatted = moment(objInstrument.AtlDate).locale(settings.uiLanguage).format('DD MMM YYYY');
                    objInstrument.HighPriceYtdDateFormatted = moment(objInstrument.HighPriceYtdDate).locale(settings.uiLanguage).format('DD MMM YYYY');
                    objInstrument.DividendDateFormatted = moment(objInstrument.DividendDate).locale(settings.uiLanguage).format('DD MMM YYYY');
                    objInstrument.QuoteTimeFormatted = moment(objInstrument.QuoteTime).locale(settings.uiLanguage).format('DD MMM YYYY HH:mm');
                    objInstrument.KeyRatioTimeFormatted = moment(objInstrument.KeyRatioTime).locale(settings.uiLanguage).format('DD MMM YYYY HH:mm');

                    var compositeModel = $.extend(objInstrument, texts, settings),
                        renderedHtml = $("#tplTickerPerformance").render(compositeModel, cision.websolution.formatHelpers);
                    htmls += renderedHtml;
                }

                $("#target-share-performance").html(htmls);
            })
            .fail(function() {
                console.log('Could not retrieve trades data');
            });
    };

    return {
        render: renderTrades,
        renderTrades: renderTrades
    };
}(jQuery);